import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
import storage from "@/utils/storage";
function getDevice(){
  let value = storage.getItem('isPC');
  if(value === undefined || value===null){
    value = true;
    if (/(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent)) { //移动端
      value = false;
    }
  }else{
    value = value == 1 ? true : false;
  }
  return value;
}
export default new Vuex.Store({
  state: {
    menuIndex: localStorage.getItem('menuTab') || -1,
    lang: localStorage.getItem('lang') || 0,
    isPC: getDevice(),
  },
  mutations: {
    changeMenu(state){
      state.menuIndex = localStorage.getItem('menuTab') || -1;
    },
    changeLang(state){
      state.lang = localStorage.getItem('lang') || 0;
    }
  },
  actions: {
  },
  modules: {
  },
})
